import { WEEKEND_EXTRAS, buildExtraOwnershipIndex, getExtraId } from './extraOwnership';
export { WEEKEND_EXTRAS } from './extraOwnership';

// Pricing defaults belong to this feature, independently of visibility rules.
export function ensureWeekendExtras(rows = [], catalog = [], ownershipIndex = null) {
  const list = Array.isArray(rows) ? rows : [];
  const index = ownershipIndex ?? buildExtraOwnershipIndex(catalog);
  const definitionsByKey = new Map(WEEKEND_EXTRAS.map(item => [item.key, item]));
  const definitionsById = new Map(WEEKEND_EXTRAS.map(item => [item.id, item]));
  const existingByKey = new Map();
  const regular = [];
  for (const row of list) {
    const id = getExtraId(row);
    const key = String(index.catalogById.get(id)?.key || row?.key || row?.Extra?.key || '').trim().toLowerCase();
    const definition = definitionsByKey.get(key) ?? definitionsById.get(id);
    if (definition) existingByKey.set(definition.key, row);
    else regular.push(row);
  }
  const weekend = WEEKEND_EXTRAS.map(definition => {
    const entry = index.catalogByKey.get(definition.key);
    const existing = existingByKey.get(definition.key);
    return {
      ...existing,
      extraId: String(entry?.id ?? existing?.extraId ?? definition.id),
      key: definition.key,
      name: entry?.name ?? `${definition.day} ${definition.action}`,
      priceType: 'ONE_TIME',
      pricePerDay: existing?.pricePerDay ?? 0,
      maxPrice: null,
      isRequired: true,
      description: existing?.description ?? '',
    };
  });
  return [...regular, ...weekend];
}
